/* eslint-disable no-const-assign */

import React from "react";
import { useState, useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";
import { SSS_ } from "./APPF_ICONS";
import { getTenantInfo } from './commons'
import { appf_tenant_info } from "../UserPool";
const bgColor = localStorage.getItem('themeKey') === 'light' ? '#000' : '#FFF'
const bigLogoSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" width={"100%"} height={"100%"} fill="none">
  <g strokeWidth=".996371" clipPath="url(#a)" opacity=".58">
    <path
      stroke="url(#b)"
      d="M1342.17 229.476v.498h40.95V145.264c0-14.698 3.78-25.297 11.24-31.92 7.48-6.64 18.86-10.005 34.23-10.005 2.73 0 5.04.105 6.92.314l.02.003h.03c1.88 0 3.28.209 4.25.597l.69.273V65.793l-.3-.1314c-2-.8897-5.26-1.3092-9.71-1.3092-12.78 0-23.78 3.619-32.96 10.8711-6.44 5.086-11.56 11.7899-15.36 20.0967V67.5183h-40V229.476Z"
      opacity=".58"
    />
    <path
      stroke="url(#c)"
      d="m1197.33 222.313.01.001c13.18 7.222 28.38 10.826 45.57 10.826s32.28-3.604 45.26-10.827c12.97-7.22 23.08-17.204 30.31-29.947 7.44-12.958 11.16-27.714 11.16-44.253 0-16.537-3.61-31.083-10.84-43.622-7.24-12.5324-17.34-22.3053-30.31-29.3131-12.98-7.223-28.18-10.8255-45.58-10.8255-17.19 0-32.38 3.6033-45.57 10.8244-12.97 7.0078-23.08 16.7811-30.31 29.3142-7.24 12.539-10.85 27.085-10.85 43.622s3.61 31.291 10.84 44.248l.01.003c7.23 12.744 17.33 22.729 30.3 29.949Zm76.92-111.539v.005c8.35 8.959 12.55 21.278 12.55 37.017 0 10.705-1.89 20.02-5.66 27.961-3.77 7.731-8.99 13.779-15.67 18.158-6.68 4.167-14.19 6.253-22.56 6.253-8.58 0-16.19-2.087-22.87-6.251-6.47-4.379-11.7-10.429-15.68-18.165-3.76-7.94-5.65-17.253-5.65-27.956 0-15.739 4.2-28.058 12.55-37.017 8.35-8.97 18.89-13.455 31.65-13.455 12.76 0 23.19 4.484 31.34 13.45Z"
      opacity=".58"
    />
    <path
      stroke="url(#d)"
      d="m1089.55 219.06.01.008c9.64 9.414 24.48 14.072 44.41 14.072 5.73 0 10.93-.423 15.62-1.273 4.66-.636 8.32-1.595 10.92-2.895l.28-.138V196.81l-.66.218c-2.51.836-5.24 1.569-8.18 2.198-2.71.416-5.85.626-9.42.626-9.03 0-15.54-1.891-19.64-5.571-4.08-3.673-6.17-9.319-6.17-17.042V99.8569h44.07V67.5185h-44.07V15.9149h-41.26v51.6036h-31.07v32.3384h31.07v76.4321c0 18.86 4.67 33.148 14.09 42.771Z"
      opacity=".58"
    />
    <path
      stroke="url(#e)"
      d="m930.548 222.307.004.002c12.554 7.225 27.014 10.831 43.364 10.831 13.376 0 25.39-2.439 36.034-7.327v-.002c10.85-5.096 19.79-12.108 26.81-21.037 7.24-9.144 11.82-19.671 13.73-31.572l.1-.577H1011.26l-.1.369c-2.3 8.556-6.68 15.21-13.13 19.99-6.454 4.782-14.272 7.184-23.48 7.184-8.365 0-15.663-2.086-21.912-6.245-6.255-4.374-11.058-10.417-14.406-18.149-3.349-7.733-5.032-16.844-5.032-27.345 0-10.288 1.682-19.293 5.032-27.028 3.349-7.735 8.048-13.67 14.088-17.831 6.247-4.1579 13.65-6.246 22.23-6.246 9.208 0 17.026 2.4016 23.48 7.184 6.45 4.78 10.83 11.434 13.13 19.99l.1.369H1050.59l-.1-.577c-1.91-11.897-6.38-22.318-13.41-31.2529-7.03-9.1405-15.97-16.1547-26.82-21.0411-10.847-5.0988-22.966-7.6436-36.344-7.6436-16.35 0-30.81 3.6054-43.364 10.8303l-.004.0019c-12.336 7.2214-22.119 17.2055-29.348 29.9434l-.001.002c-7.022 12.537-10.525 26.975-10.525 43.299 0 16.325 3.503 30.972 10.522 43.927l.004.008c7.229 12.738 17.012 22.722 29.348 29.943Z"
      opacity=".58"
    />
    <path
      stroke="url(#f)"
      d="m845.732 229.597.095.377h40.972l-.155-.619c-1.475-5.894-2.634-11.47-3.477-16.728-.631-5.254-.946-10.402-.946-15.443v-73.132c0-19.516-5.739-34.3398-17.289-44.3795-11.538-10.2406-28.478-15.3201-50.736-15.3201-21.415 0-38.543 4.6581-51.335 14.0261-12.788 9.3648-20.052 21.6235-21.759 36.7535l-.062.554h39.328l.078-.403c1.243-6.411 4.545-11.249 9.917-14.55l.004-.003c5.601-3.5215 13.107-5.3055 22.561-5.3055 9.658 0 16.695 2.203 21.214 6.5105l.008.008.009.008c4.721 4.099 7.12 10.273 7.12 18.619v7.635l-42.691 6.435c-19.707 2.963-35.019 8.789-45.89 17.517-10.905 8.755-16.354 20.616-16.354 35.529 0 13.849 4.807 24.967 14.438 33.302l.009.007c9.835 8.113 22.956 12.145 39.311 12.145 14.019 0 25.846-2.97 35.453-8.94l.002-.001c7.199-4.532 12.904-10.553 17.116-18.053.104 3.471.274 6.618.51 9.441l.001.01.001.011c.636 5.082 1.485 9.745 2.547 13.989Zm-40.336-69.595 35.883-5.453v18.258c0 8.048-3.708 14.874-11.213 20.496-7.506 5.621-16.907 8.448-28.234 8.448-7.756 0-13.768-1.57-18.092-4.652-4.297-3.272-6.455-7.865-6.455-13.845 0-6.623 2.272-11.749 6.788-15.44 4.766-3.724 11.855-6.341 21.321-7.812h.002Z"
      opacity=".58"
    />
    <path
      stroke="url(#g)"
      d="M585.486 229.475v.499H627.696V138.48h106.838v-33.605H627.696V34.6398h114.446V1.03502H585.486V229.475Z"
      opacity=".58"
    />
    <path
      stroke="url(#h)"
      d="m460.741 222.271.01.007c9.829 7.255 22.517 10.862 38.022 10.862 15.086 0 28.179-3.502 39.261-10.525 11.075-7.019 19.695-16.907 25.861-29.646 6.168-12.745 9.243-27.701 9.243-44.856 0-16.942-2.969-31.687-8.925-44.22-5.954-12.5282-14.362-22.2058-25.225-29.0141-10.659-7.0235-23.225-10.5265-37.679-10.5265-15.295 0-28.287 3.501-38.951 10.5296-7.191 4.7391-12.642 10.6455-16.347 17.7137V67.5183H406.02V294.874h40.942v-89.876c3.169 6.838 7.762 12.599 13.779 17.273Zm57.944-111.191.004.005c7.714 8.744 11.605 21.169 11.605 37.344 0 16.177-3.786 28.712-11.294 37.669-7.504 8.74-17.609 13.12-30.372 13.12-12.764 0-22.979-4.381-30.695-13.128-7.714-8.744-11.605-21.168-11.605-37.344 0-16.176 3.891-28.6 11.605-37.344l.004-.005c7.719-8.958 17.828-13.4398 30.374-13.4398 12.764 0 22.87 4.3808 30.374 13.1228Z"
      opacity=".58"
    />
    <path
      stroke="url(#i)"
      d="m279.69 222.271.009.007c9.829 7.255 22.517 10.862 38.022 10.862 15.086 0 28.179-3.502 39.261-10.525 11.075-7.019 19.695-16.907 25.861-29.646 6.168-12.745 9.243-27.701 9.243-44.856 0-16.942-2.969-31.687-8.924-44.22-5.955-12.5282-14.362-22.2058-25.226-29.0141-10.659-7.0235-23.225-10.5265-37.679-10.5265-15.294 0-28.287 3.501-38.951 10.5296-7.19 4.7391-12.641 10.6455-16.347 17.7137V67.5183H224.969V294.874H265.91v-89.876c3.169 6.838 7.762 12.599 13.78 17.273Zm57.943-111.191.004.005c7.714 8.744 11.606 21.169 11.606 37.344 0 16.177-3.787 28.712-11.295 37.669-7.503 8.74-17.609 13.12-30.372 13.12-12.764 0-22.978-4.381-30.694-13.128-7.714-8.744-11.606-21.168-11.606-37.344 0-16.176 3.892-28.6 11.606-37.344l.003-.005c7.72-8.958 17.829-13.4398 30.374-13.4398 12.764 0 22.87 4.3808 30.374 13.1228Z"
      opacity=".58"
    />
    <path
      stroke="url(#j)"
      d="m-4.0192 229.303-.24712.671H37.3822l.1161-.336 19.5091-56.333h91.6846l19.43 56.333.116.336h43.55l-.246-.67L127.848 1.36149l-.12-.32647H80.1127l-.1201.3259L-4.0192 229.303ZM102.942 40.6665l34.049 98.7165H68.7549l34.1871-98.7165Z"
      opacity=".58"
    />
  </g>
  <defs>
    <linearGradient
      id="b"
      x1="1391.34"
      x2="1462.1"
      y1="64.8506"
      y2="190.07"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="c"
      x1="1242.93"
      x2="1292.42"
      y1="64.8506"
      y2="217.142"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="d"
      x1="1102.6"
      x2="1200.18"
      y1="16.4131"
      y2="172.313"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="e"
      x1="970.599"
      x2="1023.44"
      y1="64.8506"
      y2="214.581"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="f"
      x1="811.513"
      x2="866.914"
      y1="64.8506"
      y2="212.432"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="g"
      x1="663.826"
      x2="754.117"
      y1="1.5332"
      y2="186.104"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="h"
      x1="489.592"
      x2="577.233"
      y1="64.8506"
      y2="254.727"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="i"
      x1="308.54"
      x2="396.182"
      y1="64.8506"
      y2="254.727"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <linearGradient
      id="j"
      x1="103.778"
      x2="175.86"
      y1="1.5332"
      y2="204.7"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor={bgColor} />
      <stop offset={1} stopColor={bgColor} stopOpacity={0} />
    </linearGradient>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h1440v229H0z" />
    </clipPath>
  </defs>
</svg>
)




const Login = () => {
    const navigate = useNavigate();
    const { newPass, login, initConfig } = useAuth();
    const [aMessage, setAMessage] = useState("")
    const [aTenant, setATenant] = useState(localStorage.getItem("tenantData") !== null ? JSON.parse(localStorage.getItem("tenantData")).tenant : "")
    const [clickedLogo, setClickedLogo] = useState(false)
    let localData = {};

    const handleChange = (event) => {
        let changeID = event.target.getAttribute("placeholder");
        localData[changeID] = event.target.value;

        if (changeID == 'tenant') {
            setATenant(localData[changeID]);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            let a = localData["password"];
            let b = localData["username"];

            try {
                if (a && b && a.length > 0 && b.length > 0) {
                    handleLogin();
                }
            } catch (e) { /**/ }
        }
    }

    const handleLogin = async (a) => {
        if (typeof localData === 'undefined') {
            localData = {}
        }

        if (typeof localData.username === 'undefined' ||
            typeof localData.password === 'undefined' ||
            typeof localData.tenant === 'undefined') {
            try {
                // Populate localData from current input values without overwriting the object
                document.querySelectorAll("input[placeholder]").forEach((el) => {
                    const key = el.getAttribute('placeholder');
                    if (key) {
                        localData[key] = el.value;
                    }
                });
            } catch (e) {/**/ }
        }
        let errMessage = "";
        if (typeof localData.tenant === 'undefined' || localData.tenant == "") {
            errMessage = "'tenant'"
        }

        if (typeof localData.username === 'undefined' || localData.username == "") {
            if (errMessage != "") {
                errMessage += " and "
            }
            errMessage += "'username'"
        }

        if (typeof localData.password === 'undefined' || localData.password == "") {
            if (errMessage != "") {
                errMessage += " and "
            }
            errMessage += "'password'"
        }

        if (errMessage != "") {
            setAMessage("Missing requiered parameter " + errMessage);
            return;
        }

        let tTinfo = await getTenantInfo(localData.tenant);
        if (tTinfo.type == 'firebase') {
            initConfig(tTinfo.config)
        }

        // Let the root Apollo client (created via getNewApolloClient) handle headers and tokens

        try {
            a.target.parentNode.parentNode.classList.add("clipit");
            try {
                document.querySelector("#lookAtTheStars").innerHTML = "";
                document.querySelector(".stars").innerHTML = "";
            } catch (e) { /**/ }
        } catch (e) {/* */ }

        login(localData.username, localData.password, tTinfo.poolId, tTinfo.clientId).then(async (a) => {
            tTinfo.username = localData.username;

            if (newPass || a.newPass) {
                localStorage.setItem("tenantData", JSON.stringify(tTinfo));
                window._g.changePass = a;
                navigate("/newpass", { replace: true });
            }
            else {
                if( appf_tenant_info.type == "standalone"){
                    localStorage.setItem("tenantData", JSON.stringify(appf_tenant_info));    
                }else{
                    localStorage.setItem("tenantData", JSON.stringify(tTinfo));
                }

                navigate("/", { replace: true });
                // window.location.reload()
                console.log("[7] - Reloading ... ")
            }
        }).catch((e) => {
            try {
                a.target.parentNode.parentNode.classList.remove("clipit")
            } catch (e) {/* */ }

            setAMessage(e.message);
        });
    };

    const tenantRef = useRef(null);
    const userRef = useRef(null);
    useEffect(() => {
        try {
            let host = window.location.host.split(".");
            if (host.length == 3) {
                tenantRef.current.value = host[0];
                userRef.current.focus();
            } else {
                tenantRef.current.focus();
            }
        } catch (e) {/**/ }

    }, []);

    let scriptData = "";
    const xData = "20.9_0 0;-1102.9 5.6_118.3_0 0;2512.4 -882.7_177.3_0 0;4492.7 860.8_30.9_0 0;-734.1 -334.8_9.8_0 0;-1403.7 497.3_154.1_0 0;-923.4 2178.9_17.5_0 0;-1212.4 145.5_124.5_0 0;2750.1 -818.1_104.7_0 0;984.5 2970.3_88.3_0 0;1560.0 2999.6_96.1_0 0;1714.5 -994.9_32.8_0 0;3656.6 2390.3_128.5_0 0;95.2 2767.2_135.6_0 0;-186.6 2654.0_144.5_0 0;3550.5 -459.9_30.8_0 0;3738.0 2331.9_1.2_0 0;4498.4 1064.5_5.7_0 0;4466.9 1296.1_42.9_0 0;3250.1 2624.4_167.5_0 0;4346.1 367.6_55.2_0 0;2760.8 2814.8_25.5_0 0;3938.6 2164.9_22.5_0 0;4047.0 2056.8_135.4_0 0;-181.0 2656.5_25.8_0 0;-929.8 -173.1_7.8_0 0;-1438.9 598.3_25.0_0 0;-956.5 -148.0_0.2_0 0;-1500.0 989.4_115.3_0 0;2402.5 -907.4_19.7_0 0;-1144.1 55.1_97.1_0 0;1251.9 2993.1_108.2_0 0;2143.3 -953.5_170.8_0 0;4415.7 529.2_14.7_0 0;-1291.4 267.2_141.2_0 0;3416.3 -538.8_15.0_0 0;4282.6 1747.4_89.2_0 0;1527.8 2999.9_16.9_0 0;-1231.1 172.4_15.6_0 0;4267.9 1771.3_143.1_0 0;-493.8 2494.4_138.0_0 0;-283.8 2608.1_144.3_0 0;3538.5 -467.3_62.3_0 0;508.7 -887.7_134.4_0 0;-139.6 2674.9_42.2_0 0;3276.7 2611.5_156.0_0 0;-994.9 2110.7_136.7_0 0;-232.8 2632.7_142.5_0 0;3466.6 -510.3_90.5_0 0;1482.2 3000.0_92.6_0 0;1408.2 2999.1_33.0_0 0;-649.6 -395.1_166.0_0 0;4310.1 299.7_23.8_0 0;4003.4 2102.1_32.8_0 0;3658.4 2389.1_130.2_0 0;2972.6 -742.5_89.9_0 0;1495.9 -1000.0_28.0_0 0;-845.6 -246.9_7.2_0 0;4447.0 1374.5_75.1_0 0;976.0 -969.3_61.1_0 0;2536.8 2876.8_25.5_0 0;3938.5 2165.0_99.1_0 0;1181.0 2988.7_43.7_0 0;3215.7 2640.6_160.2_0 0;-1140.7 1949.0_170.8_0 0;-1414.7 1473.6_25.7_0 0;3932.9 2170.2_167.3_0 0;4342.9 361.3_88.0_0 0;1430.8 -999.5_6.3_0 0;-1460.1 674.9_155.7_0 0;-983.2 2122.3_103.1_0 0;1960.2 -976.3_153.3_0 0;-895.1 2204.3_71.8_0 0;856.5 -953.4_58.2_0 0;2646.9 2848.1_129.7_0 0;48.7 2750.4_41.6_0 0;3299.3 2600.3_20.4_0 0;4119.3 1975.1_19.8_0 0;4138.3 1952.0_55.8_0 0;2739.4 2821.3_165.8_0 0;4303.6 288.2_25.3_0 0;-947.9 -156.2_22.3_0 0;4053.7 2049.5_176.2_0 0;4485.3 802.3_175.7_0 0;-1481.4 1222.1_117.1_0 0;530.4 2892.7_39.9_0 0;-369.3 -564.3_55.1_0 0;234.2 -813.2_23.3_0 0;4019.4 2085.8_113.3_0 0;670.3 2922.0_26.8_0 0;3891.7 2207.3_98.1_0 0;1782.7 -991.1_36.6_0 0;3505.4 2487.5_66.9_0 0;678.9 -923.6_96.7_0 0;1267.2 2994.0_54.1_0 0;195.4 -801.0_102.0_0 0;1920.0 -980.3_62.0_0 0;497.5 -885.0_112.8_0 0;2309.4 -925.8_53.5_0 0;172.4 -793.5_163.5_0 0;-1241.8 1811.8_96.6_0 0;1732.0 -994.0_1.8_0 0;4496.8 1092.9_76.4_0 0;1977.6 2974.5_169.1_0 0;-1382.2 1554.8_153.3_0 0;3896.1 -203.4_138.6_0 0;3310.0 -595.0_118.1_0 0;2504.3 -884.6_144.4_0 0;-543.7 2464.1_151.8_0 0;-839.1 2252.3_147.1_0 0;-653.3 2392.5_13.2_0 0;4329.4 1664.9_0.8_0 0;-1499.4 959.8_31.3_0 0;3714.8 2349.0_176.4_0 0;-1486.6 1188.6_141.2_0 0;3414.1 -540.0_48.3_0 0;-30.4 -720.2_5.9_0 0;4465.0 1304.5_143.0_0 0;3489.5 -497.0_144.8_0 0;3559.0 -454.6_139.4_0 0;-340.7 2579.3_158.9_0 0;4097.4 -0.7_141.4_0 0;-424.7 2534.1_150.6_0 0;-792.9 2289.7_77.3_0 0;1055.2 -977.9_126.9_0 0;155.8 2788.0_29.7_0 0;-777.6 -301.7_144.3_0 0;-538.7 2467.2_114.9_0 0;611.4 2910.2_178.4_0 0;4497.3 914.9_84.5_0 0;1307.9 -995.9_37.1_0 0;3483.1 2500.7_161.5_0 0;4181.2 102.8_6.2_0 0;-1461.3 680.0_39.2_0 0;3399.4 2548.1_20.1_0 0;4128.8 1963.7_17.6_0 0;4207.7 1861.2_71.3_0 0;2159.9 2951.0_140.9_0 0;3402.7 -546.3_18.6_0 0;-1178.5 99.2_19.9_0 0;-1135.8 44.9_126.0_0 0;193.6 2800.4_170.2_0 0;-1404.2 1501.4_170.3_0 0;4406.1 503.6_5.6_0 0;4467.9 1291.8_128.6_0 0;91.7 2765.9_69.5_0 0;2223.9 2940.9_31.7_0 0;-698.8 -360.6_35.5_0 0;3546.9 2462.1_137.5_0 0;3264.4 -617.5_174.5_0 0;4468.7 712.0_164.9_0 0;-1279.9 1752.0_170.3_0 0;4405.3 501.4_6.1_0 0;4462.5 1315.1_2.5_0 0;-1493.5 868.1_32.6_0 0;3666.2 2383.7_36.8_0 0;3495.1 2493.6_79.7_0 0;1140.7 -985.6_177.5_0 0;4493.8 871.9_36.3_0 0;3516.2 2481.0_137.5_0 0;-264.1 2617.7_17.3_0 0;-1217.4 152.6_30.8_0 0;3736.9 2332.7_114.5_0 0;627.1 2913.5_130.4_0 0;2978.7 -740.2_2.3_0 0;-1494.7 881.0_19.1_0 0;-1161.2 76.7_46.9_0 0;-86.7 -697.4_55.4_0 0;247.3 -817.3_24.3_0 0;-984.2 -121.2_7.3_0 0;4446.8 1375.0_133.1_0 0;3089.5 -696.2_95.2_0 0;1319.6 2996.4_16.2_0 0;4250.4 1798.7_133.0_0 0;-84.2 2698.4_128.8_0 0;81.0 2762.1_70.2_0 0;2200.7 2944.7_133.0_0 0;-83.5 2698.7_152.0_0 0;-847.2 2245.6_4.8_0 0;-1476.6 750.7_28.1_0 0;-841.2 -250.5_108.5_0 0;2153.0 -952.1_44.0_0 0;3205.5 2645.4_86.2_0 0;1634.3 2998.0_152.5_0 0;-865.7 2229.9_2.2_0 0;-1495.1 885.3_42.9_0 0;-248.1 -625.4_156.9_0 0;-1026.8 2078.1_124.9_0 0;2765.8 -813.2_27.4_0 0;-868.0 -228.0_137.1_0 0;3247.2 -625.8_119.2_0 0;2549.0 -873.7_94.5_0 0;1341.7 2997.2_112.5_0 0;702.7 2928.1_18.8_0 0;-1173.2 92.3_141.1_0 0;3409.5 -542.6_47.6_0 0;3060.6 2708.1_142.1_0 0;3452.7 -518.3_157.6_0 0;-1052.1 2051.3_80.2_0 0;1841.7 2987.0_27.3_0 0;3871.0 2225.3_65.0_0 0;608.0 -909.5_49.7_0 0;2974.9 2741.6_59.0_0 0;2614.8 2856.8_94.7_0 0;1336.7 2997.0_158.9_0 0;4098.0 -0.1_141.5_0 0;3428.3 -532.1_129.8_0 0;42.4 2748.1_100.0_0 0;1149.9 2986.3_159.9_0 0;4130.5 38.5_130.3_0 0;2975.8 -741.3_41.0_0 0;3327.0 2586.3_25.9_0 0;3925.3 2177.2_168.4_0 0;4368.2 413.8_5.4_0 0;4470.6 1279.1_0.1_0 0;-1500.0 993.5_81.2_0 0;1192.4 -989.5_1.3_0 0;-1498.2 930.6_150.6_0 0;3789.8 -292.1_44.9_0 0;-169.5 -661.7_120.6_0 0;400.6 2860.9_65.8_0 0;639.6 -916.0_81.6_0 0;1793.5 2990.4_134.3_0 0;-137.2 2675.9_53.1_0 0;156.2 -788.1_44.8_0 0;-171.3 -660.9_5.0_0 0;4474.9 1258.2_86.8_0 0;1387.9 -998.6_115.1_0 0;2395.4 -908.8_45.6_0 0;3141.2 2674.2_67.8_0 0;712.6 -929.9_122.5_0 0;326.9 2840.7_151.9_0 0;-840.0 2251.6_139.2_0 0;3333.9 -582.8_14.0_0 0;4310.2 1700.0_164.4_0 0;4267.7 228.3_10.7_0 0;-1386.1 454.0_35.0_0 0;3570.6 2447.3_23.7_0 0;-1004.7 -100.8_167.3_0 0;-1341.3 1641.9_173.3_0 0;-1454.4 1347.2_166.0_0 0;-1310.9 1698.9_138.0_0 0;3285.8 -607.1_69.1_0 0;2240.1 2938.2_161.3_0 0;4173.6 92.8_160.5_0 0;-1147.9 1940.2_119.6_0 0;436.9 2870.2_78.8_0 0;1891.2 2982.9_84.4_0 0;1305.6 -995.8_116.0_0 0;2429.5 -901.6_112.5_0 0;2298.9 -927.8_89.6_0 0;1487.0 -1000.0_4.1_0 0;4483.1 1212.2_177.0_0 0;-1490.6 1158.5_22.4_0 0;-1052.3 -51.1_28.7_0 0;3818.0 2269.6_154.7_0 0;-947.4 2156.7_22.6_0 0;-1044.9 -59.0_73.5_0 0;918.9 -962.1_171.9_0 0;4433.4 580.9_134.6_0 0;-149.2 2670.7_0.6_0 0;-1499.6 966.8_98.0_0 0;1780.6 -991.2_160.2_0 0;-1139.2 1951.0_61.1_0 0;465.1 -877.2_80.6_0 0;1172.6 -988.1_74.2_0 0;942.6 -965.2_39.6_0 0;3383.8 2556.5_168.3_0 0;4365.6 408.0_143.3_0 0;-499.7 2490.9_137.7_0 0;-274.0 2612.9_167.8_0 0;4352.8 381.3_42.0_0 0;3284.0 2608.0_25.6_0 0;3934.5 2168.7_165.6_0 0;-1298.5 1720.6_85.5_0 0;1657.4 2997.2_163.6_0 0;-1243.8 1808.8_64.7_0 0;2402.0 2907.5_34.8_0 0;3576.6 2443.4_151.7_0 0;3835.0 -255.7_65.1_0 0;611.8 -910.3_143.7_0 0;-514.4 2482.1_92.2_0 0;1575.5 -999.4_108.5_0 0;2153.6 -952.0_178.4_0 0;-1497.3 1085.4_7.6_0 0;4441.4 1393.3_13.6_0 0;-1318.8 315.5_85.3_0 0;1662.6 2997.1_55.2_0 0;2763.1 2814.1_83.5_0 0;1273.4 -994.3_130.5_0 0;15.8 2738.1_108.8_0 0;2164.0 -950.4_33.5_0 0;3628.8 2409.2_25.9_0 0;-925.8 -176.7_1.4_0 0;4498.1 1071.0_23.6_0 0;-1008.3 -97.2_179.8_0 0;-1500.0 1010.4_23.1_0 0;4028.4 2076.5_110.1_0 0;2210.5 -943.1_10.2_0 0;-1395.5 476.6_95.8_0 0;1703.9 -995.4_6.7_0 0;-1454.0 651.1_167.9_0 0;4355.5 386.7_28.8_0 0;3815.2 2271.9_1.8_0 0;-1496.8 907.9_5.4_0 0;4470.7 1278.9_106.1_0 0;2065.1 -964.2_96.4_0 0;1276.8 2994.5_174.3_0 0;4467.2 704.9_155.4_0 0;3972.7 -132.5_60.1_0 0;427.9 -867.9_100.1_0 0;1147.3 2986.1_100.1_0 0;1855.2 -985.9_137.7_0 0;-274.0 2612.9_39.5_0 0;3385.2 2555.8_77.9_0 0;1077.1 -980.0_4.6_0 0;4478.1 1241.2_156.1_0 0;3997.9 -107.7_153.5_0 0;3902.5 -197.7_160.9_0 0;-1162.8 1921.3_12.4_0 0;-1349.5 374.5_48.9_0 0;-9.0 -728.6_58.7_0 0;374.5 -853.9_127.1_0 0;2849.8 -786.1_162.0_0 0;4198.2 125.8_41.5_0 0;3305.7 2597.2_30.8_0 0;3734.9 2334.2_21.7_0 0;-1077.7 -23.2_5.4_0 0;-1469.9 717.5_54.7_0 0;220.9 -809.1_129.5_0 0;55.9 2753.0_111.7_0 0;2267.7 -933.4_159.3_0 0;-1109.9 1986.2_39.4_0 0;-392.0 -552.1_108.6_0 0;2156.7 -951.5_121.1_0 0;2619.5 -855.5_71.7_0 0;855.9 -953.4_93.0_0 0;1395.2 2998.8_22.1_0 0;-1061.0 -41.6_14.6_0 0;4295.2 1726.3_128.3_0 0;102.6 2769.8_1.9_0 0;4496.1 1101.7_145.5_0 0;-588.2 2435.9_88.7_0 0;1546.6 2999.8_34.3_0 0;3596.5 2430.6_137.4_0 0;3259.7 -619.8_134.0_0 0;3122.1 -682.4_1.9_0 0;-1496.2 899.0_116.3_0 0;2437.5 -899.8_163.4_0 0;-1238.4 1816.8_168.5_0 0;-1369.1 1584.3_36.7_0 0;3498.3 2491.7_179.1_0 0;-1499.1 1048.0_177.3_0 0;-1492.5 1141.1_169.3_0 0;4387.3 456.9_113.5_0 0;2333.6 -921.2_150.5_0 0;3788.0 -293.6_100.4_0 0;1862.9 -985.3_0.4_0 0;4499.8 1021.0_147.9_0 0;3683.3 -371.7_124.4_0 0;253.9 2819.3_133.2_0 0;-92.1 2695.1_96.5_0 0;1726.7 -994.3_73.4_0 0;915.8 -961.7_55.4_0 0;244.8 -816.5_23.3_0 0;4018.6 2086.6_115.4_0 0;594.5 2906.7_14.1_0 0;-1306.3 293.1_24.8_0 0;-964.7 -140.2_115.5_0 0;590.2 2905.8_162.4_0 0;4210.4 142.6_1.1_0 0;-1498.7 940.2_153.6_0 0;-907.9 2192.9_26.3_0 0;3911.1 2190.1_3.1_0 0;4490.5 1159.4_178.6_0 0;-1498.1 1072.1_68.9_0 0;751.5 -936.8_166.0_0 0;-1309.5 1701.3_70.4_0 0;2191.6 2946.1_56.9_0 0;2697.0 2833.9_8.7_0 0;4424.0 1447.2_45.2_0 0;-155.0 -668.1_140.8_0 0;-398.7 2548.5_17.6_0 0;4207.9 1860.8_60.2_0 0;429.5 -868.3_66.3_0 0;657.1 -919.4_30.9_0 0;-732.8 -335.8_146.9_0 0;-646.5 2397.2_25.1_0 0;-955.5 -149.0_56.8_0 0;299.9 -833.0_136.7_0 0;3232.1 -633.0_8.1_0 0;-1434.4 584.0_14.5_0 0;-1297.1 277.0_95.0_0 0;1326.5 2996.7_141.6_0 0;-431.9 2530.1_170.5_0 0;-1410.0 1486.1_148.5_0 0;3710.4 -352.2_131.0_0 0;-5.2 2730.1_6.7_0 0;-1454.3 652.2_113.5_0 0;664.0 2920.8_132.8_0 0;-77.0 2701.4_";

    let mouse = {}

    function getPos(a, b) {
        return (a / (Math.log(a)) * 16.42 - (a / 1.4)) - b / (Math.log(a));
    }

    function goForIt() {
        let xx = 2000;
        let yy = 3500;
        if (window.innerWidth > 500) {
            xx = yy = 0;
        }

        mouse = {
            x: getPos((parseInt(window.innerWidth) + xx) / 2, parseInt(window.innerWidth) + xx),
            y: getPos((parseInt((window.innerHeight) + yy) / 2) / 2.2, parseInt(window.innerHeight) + yy)
        };


        let x = xData.split('_');
        let res = "";
        let colors = [
            '#F8DB78',
            '#801C08',
            '#801C08',
            '#FFFFFF',
            '#D64324'
        ];

        function getColor() {
            return colors[Math.floor(Math.random() * (5))];
        }

        function getRandomFloat(min, max, decimals) {
            const str = (Math.random() * (max - min) + min).toFixed(decimals);
            return parseFloat(str);
        }

        let vv = [];
        // let j = 0;
        let duration = 8;
        for (let i = 0; i < x.length; i += 2) {
            duration = getRandomFloat(5, 18, 1);
            // j++;
            if (x[i] == "") {
                break;
            }
            let vals = `${x[i + 1]}`;
            vv = vals.split(";");

            vv[0] = `${mouse.x} ${mouse.y}`;
            vals = vv.join(";");
            let beg1 = getRandomFloat(-5, 5, 1);
            // let scr = duration/10;
            let special = (Math.floor(Math.random() * 100) == 1);
            if (special) {
                // scr = 2;
            }
            res += `<g >
                <animateTransform attributeName="transform" type="translate" repeatCount="10" calcMode="spline" keySplines="1 0 1 0" values="${vals}" keyTimes="0;1" dur="${duration}s" begin="${beg1}s" /> 
                <g transform="rotate(${x[i]})" >
                      <ellipse ${special ? "filter='url(#sst)'" : ""} fill="${special ? 'red' : getColor()}" >
                      <animate attributeName="ry" values="0;14.2" keyTimes="0;1" repeatCount="10" dur="${duration}s" begin="${beg1}s" calcMode="spline" keySplines="1 0 1 0" />
                      <animate attributeName="rx" values="0;42" keyTimes="0;1" repeatCount="10" dur="${duration}s" begin="${beg1}s" calcMode="spline" keySplines="0.95 0 0.95 0.05" />                  
                      </ellipse>
                      </g> </g>`
        }

        return res;
    }

    scriptData = !clickedLogo ? `<div style='height:100vh; width:100%'></div>` : `
    <svg xmlns="http://www.w3.org/2000/svg" id="lookAtTheStars" style="margin: auto; background:rgba(0,0,0,1); display: block; z-index:0; position: relative; shapeRendering: auto;" width="100%" height="100%" preserveAspectRatio="xMidYMid" viewBox="0 0 3000 2000">
    <defs>
    <filter id="sst" filterUnits="userSpaceOnUse" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur5"/>
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur10"/>
        <feGaussianBlur in="SourceGraphic" stdDeviation="20" result="blur20"/>
        <feGaussianBlur in="SourceGraphic" stdDeviation="30" result="blur30"/>
        <feGaussianBlur in="SourceGraphic" stdDeviation="50" result="blur50"/>
        <feMerge result="blur-merged">
            <feMergeNode in="blur10"/>
            <feMergeNode in="blur20"/>
            <feMergeNode in="blur30"/>
            <feMergeNode in="blur50"/>
        </feMerge>
        <feColorMatrix result="red-blur" in="blur-merged" type="matrix" values="1 0 0 0 0 
        0 0.06 0 0 0
        0 0 0.44 0 0
        0 0 0 1 0"/>
        <feMerge>
            <feMergeNode in="red-blur"/>
            <feMergeNode in="blur5"/>   
            <feMergeNode in="SourceGraphic"/>  
        </feMerge>
    </filter>

    </defs>
    <g>
    ${goForIt()}
    </g>

    </svg>
    `
    const debounce = (callback, wait) => {
        let timeoutId = null;
        return (...args) => {
            if (timeoutId == null) {
                callback.apply(null, args);
            }

            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                callback.apply(null, args);
            }, wait);
        };
    }

    const hMove = debounce((event) => {
        mouse.x = event.clientX;
        mouse.y = event.clientY;

        document.querySelectorAll("animateTransform").forEach(at => {
            let x = at.getAttribute("values").split(";");
            x[0] = `${getPos(mouse.x, window.innerWidth)} ${getPos(mouse.y, window.innerHeight)}`;
            at.setAttribute("values", x.join(";"));
        });
    }, 0);

    return (
        <>
<div style={{
    position: "absolute",
    bottom: "calc(0.42vw)",
    left: "calc(3.24vw)",
    width: "100%",
    height: "12px",
    fontSize: "0.642vw",
    fontWeight: "bold",
    textAlign: "left",
    zIndex: 1000,
    color: "rgba(255,255,255,0.142)"
    }}>{window.APPFACTOR_VERSION}</div>

<div style={{
                
                // backgroundPosition: "50% -42px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100rem",
                backgroundAttachment: "scroll",
                // top: 0,
                left: 0,
                position: "absolute",
                // backgroundColor: "rgba(255,0,0,0.5)",
                width: "100%",
                height: "20%",
                opacity:0.242,
                zIndex: -2,
                bottom:0,
            }}>
                {bigLogoSvg}
            </div>

            {(`${localStorage.isGoogle}` === `true`) ? <div style={{
                background: "url(./img/gcp.svg) no-repeat",
                backgroundSize: 42,
                color: "white",
                width: 200,
                height: 200,
                left: 10,
                top: 10,
                position: "fixed"
            }}>
            </div> : <></>}
            <div className="login-window" style={{
                justifyContent: window.innerWidth > 500 ? "center" : "center",
                height: "calc(100vh)",
                marginLeft: 0,
                position: "relative",
            }} >

            <div style={{
                
                backgroundSize: "100vw",
                backgroundColor:"transparent",
                backgroundPosition: "bottom",
                position: "absolute",
                bottom: 0,
                left: 0,
                // backgroundColor: "rgba(255,0,0,0.5)",
                width: "100%",
                height: "100%",
                zIndex: -1,
            }}>
                
            </div>

                <div
                onClick={() => {
                    console.log("clicked", window.location);
                    window.location.href = "/dashboard";
                }}
                    onMouseMove={hMove}
                    className="stars"
                    width="100%" height="100vh"
                    dangerouslySetInnerHTML={{ __html: scriptData }} />
                <div className="aform seethrough" style={{
                    paddingBottom: window.innerWidth > 500 ? "62px" : "0",
                }}>








<div style={{
                background: "url(./img/appflogo.svg) no-repeat",
                backgroundSize: "100%",
                backgroundColor:"transparent",
                backgroundPosition: "bottom",
                position: "absolute",
                bottom: 0,
                left: 0,
                // backgroundColor: "rgba(255,0,0,0.5)",
                width: "100%",
                height: "100%",
                opacity:1,
                zIndex: -12,
            }}>

            </div>

                    <div style={{
                        marginLeft: 20,
                        marginTop: -4,
                        paddingBottom: 4,
                        minWidth: 120,
                        minHeight: 64,
                        // border:"1px solid rgba(255,255,255,0.42)",
                        background:"url(./img/appflogonew.svg) no-repeat",
                        backgroundSize: "182px",
                    }} onDoubleClick={(e) => {
                        if (e.shiftKey == true) {
                            localStorage.isGoogle = `${localStorage.isGoogle}` === `true` ? 'false' : 'true';
                            window.location.reload()
                        }
                        setClickedLogo(true);
                    }
                    }>
                        <div style={{
                            marginTop:4,
                            marginLeft:10,
                        }}>{SSS_}</div>
                    </div>
                    <form style={{ paddingLeft: 10, paddingTop: 0, paddingBottom: 0 }}>
                        <input onFocus={() => {
                            try { document.querySelector(".aform.seethrough").classList.remove("seethrough"); } catch (e) {/**/ }
                        }}
                            type="text" placeholder="tenant" name="tenant" autoComplete="tenant" id="appf-tenant"
                            onKeyDown={handleKeyDown} onChange={handleChange}
                            value={aTenant}
                            ref={tenantRef}
                            style={{
                                border: "unset",
                                filter: "drop-shadow(1px 1px 3px rgba(0,0,0,0.4))",
                                paddingLeft: "36px",
                            }}></input>
                        <div style={{
                            maxHeight: 10,
                            fontSize: 20,

                            color: "rgba(255,255,255,0.42)",
                            position: "absolute",
                            marginTop: -56,
                            paddingLeft: "16px",
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.5" clipPath="url(#clip0_1843_928)">
                                    <path d="M6 15C7.1 15 8 15.9 8 17C8 18.1 7.1 19 6 19C4.9 19 4 18.1 4 17C4 15.9 4.9 15 6 15ZM6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3ZM18 15C19.1 15 20 15.9 20 17C20 18.1 19.1 19 18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15ZM18 13C15.8 13 14 14.8 14 17C14 19.2 15.8 21 18 21C20.2 21 22 19.2 22 17C22 14.8 20.2 13 18 13Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1843_928">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <input onFocus={() => {
                            try { document.querySelector(".aform.seethrough").classList.remove("seethrough"); } catch (e) {/**/ }
                        }}
                            type="text"
                            placeholder="username"
                            name="id"
                            ref={userRef}
                            autoComplete="username"
                            id="appf-username" onKeyDown={handleKeyDown} onChange={handleChange}
                            style={{
                                border: "unset",
                                filter: "drop-shadow(1px 1px 3px rgba(0,0,0,0.4))",
                                paddingLeft: "36px",
                            }}></input>
                        <div style={{
                            fontSize: 20,
                            color: "rgba(255,255,255,0.42)",
                            position: "absolute",
                            marginTop: -56,
                            paddingLeft: "16px",
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.5" clipPath="url(#clip0_1726_949)">
                                    <path d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1726_949">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <input type="password" placeholder="password" name="password" autoComplete="current-password" id="appf-password" onKeyDown={handleKeyDown} onChange={handleChange}
                            style={{
                                filter: "drop-shadow(1px 1px 3px rgba(0,0,0,0.4))",
                                paddingLeft: "36px",
                            }}></input>
                    </form>
                    <div style={{
                        fontSize: 20,
                        color: "rgba(255,255,255,0.42)",
                        position: "absolute",
                        marginTop: -56,
                        paddingLeft: "26px",
                    }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.5" clipPath="url(#clip0_1726_952)">
                                <path d="M2 17H22V19H2V17ZM3.15 12.95L4 11.47L4.85 12.95L6.15 12.2L5.3 10.72H7V9.22H5.3L6.15 7.75L4.85 7L4 8.47L3.15 7L1.85 7.75L2.7 9.22H1V10.72H2.7L1.85 12.2L3.15 12.95ZM9.85 12.2L11.15 12.95L12 11.47L12.85 12.95L14.15 12.2L13.3 10.72H15V9.22H13.3L14.15 7.75L12.85 7L12 8.47L11.15 7L9.85 7.75L10.7 9.22H9V10.72H10.7L9.85 12.2ZM23 9.22H21.3L22.15 7.75L20.85 7L20 8.47L19.15 7L17.85 7.75L18.7 9.22H17V10.72H18.7L17.85 12.2L19.15 12.95L20 11.47L20.85 12.95L22.15 12.2L21.3 10.72H23V9.22Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1726_952">
                                    <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div className="appf-loginc">
                        <button id="appf-login" className="appf-login abutton" onClick={handleLogin}
                        >LOGIN</button>
                    </div>
                    <div style={{ color: "var(--color-main-pink)", fontSize: 10, padding: 20, marginBottom: 0, paddingTop: 20 }}>{aMessage}</div>
                    {/* <div className="bg-gradient-blur-wrapper home-hero-1" style={{ position: "absolute", marginTop: "-330px", marginLeft: "70px", filter: "blur(142px)", transform: "scale(0.3)", pointerEvents: "none" }}>
                        <div className="bg-gradient-blur-circle-3"></div><div className="bg-gradient-blur-circle-2"></div><div className="bg-gradient-blur-circle-1"></div>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default Login